export default {
	"exceptcreate": {
		"getFileLable": "Automatically get related photos/attachments"
	},
	"exceptdeal": {
		"batchRe": "reprocess",
		"exceptionStatus": "abnormal state",
		"handlePerson": "handler",
		"exceptionGrade": "exception level",
		"exceptionReason": "Abnormal",
		"overdueTime": "Handling overdue time",
		"exceptionFinish": "processing completed",
		"exceptionInfo": "exception information",
		"slight": "slight",
		"serious": "serious",
		"losingPartner": "Responsible party",
		"our": "our side",
		"other": "other side",
		"compensation": "Amount of compensation (yuan)",
		"tips": "Responsible person (click enter can key in directly)",
		"tips1": "Please enter the responsible person",
		"executDescription": "Handling instructions",
		"exceptionDescription": "exception description",
		"tips2": "Please select a row with status Processed or Closed",
		"tips3": "Status must be Processed or Closed to be reprocessed.",
		"tisp4": "Are you sure you want to reprocess",
		"tisp5": "Please save before confirming",
		"tisp6": "Exception status must be New",
		"exceptionExecuteLable": "Definition of responsibility",
		"exceptdealTitle": "Handling exceptions",
		"cancelDeal": "Reprocessing cancelled"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/except/except.js